import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { formatPrice } from "../utils/formatPrice";
import { productDetails } from '../services/Product-service';
function Similar({similarProducts}) {

    const [lowestPrices, setLowestPrices] = useState({});

    useEffect(() => {
        if (!similarProducts || similarProducts.length === 0) return;

        similarProducts.forEach((product) => {
            const prodId = product.id;
            if (prodId && lowestPrices[prodId] === undefined) {
                setLowestPrices((prev) => ({ ...prev, [prodId]: null }));

                productDetails(prodId)
                    .then((data) => {
                        if (data && data.productvariants && data.productvariants.length > 0) {
                            const sizeOrder = ['3xs', 'xxs', 'xs', 's', 'm', 'l', 'xl', '2xl', 'xxl', '3xl', 'xxxl', '4xl', '5xl', '6xl'];
                            const sortedVars = [...data.productvariants].sort((a, b) => {
                                const sizeA = (a.size || '').toLowerCase().trim();
                                const sizeB = (b.size || '').toLowerCase().trim();
                                const indexA = sizeOrder.indexOf(sizeA);
                                const indexB = sizeOrder.indexOf(sizeB);
                                if (indexA === -1 && indexB === -1) return 0;
                                if (indexA === -1) return 1;
                                if (indexB === -1) return -1;
                                return indexA - indexB;
                            });
                            const lowestVariant = sortedVars[0];
                            if (lowestVariant) {
                                setLowestPrices((prev) => ({
                                    ...prev,
                                    [prodId]: {
                                        price: Number(lowestVariant.price) || 0,
                                        saleprice: Number(lowestVariant.saleprice) || 0
                                    }
                                }));
                            } else {
                                setLowestPrices((prev) => ({
                                    ...prev,
                                    [prodId]: {
                                        price: Number(product.price) || 0,
                                        saleprice: Number(product.saleprice) || 0
                                    }
                                }));
                            }
                        } else {
                            setLowestPrices((prev) => ({
                                ...prev,
                                [prodId]: {
                                    price: Number(product.price) || 0,
                                    saleprice: Number(product.saleprice) || 0
                                }
                            }));
                        }
                    })
                    .catch((err) => {
                        console.error(`Error fetching lowest price for product ${prodId}`, err);
                        setLowestPrices((prev) => ({
                            ...prev,
                            [prodId]: {
                                price: Number(product.price) || 0,
                                saleprice: Number(product.saleprice) || 0
                            }
                        }));
                    });
            }
        });
    }, [similarProducts]);
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      };
    return (
        similarProducts?.length>0 && (
        <div className='App HomeSection'>
            <div className="BreakPointContainer">
                <div className="CarouselSectionContainer CarouselOneSectionContainer" >
                    <div className="layout row justify-space-between align-center text-left SectionTitle">
                        <h1 className='m-t-0 m-b-0 demi-bold w-auto'> SIMILAR PRODUCTS </h1>
                        <Link to={`/category`} className="ViewAllUrlsLink orat-color-hover h5 demi-bold w-auto"> VIEW ALL </Link>
                    </div>
                    <Slider key={Object.keys(lowestPrices).length} className='owl-theme'  {...settings}>
                    {similarProducts?.map((data, index) => (
                        <div className='item' key={index}>
                        <div className="CarouselSection product">
                            <div className="prel Gutter try_all">
                                <Link   to={`/products/productdetails/${data.id}`} >
                                    <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '130%', overflow: 'hidden' }} onClick={() => { scrollToTop(); }}>
                                        <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '20%' }}>
                                            <img src={data.product_thumbail} alt={data.product_title} className='img-resp DynamicHeightLoaderImage' style={{ padding: '0px' }} />
                                           
                                        </div>
                                        <div className="animated-bg-placeholder"></div>
                                    </div>
                                    {/* <div className="image-gradient"></div> */}
                                    <div className="ImageTextDetail ProductImageTextDetail">
                                        <label className="ellipsis h5 ImageTextLabelTop m-t-5 demi-bold"> {data.product_title} </label>
                                        <label className="h6 ellipsis-two-line font-normal ImageTextLabelBottom block font-normal">{data.product_short_description}</label>
                                        <div className="ProductPrice layout row wrap">
                                            {(() => {
                                                const lowestInfo = lowestPrices[data.id];
                                                const finalPrice = lowestInfo 
                                                    ? (lowestInfo.saleprice > 0 ? lowestInfo.saleprice : lowestInfo.price)
                                                    : (data?.saleprice > 0 ? data.saleprice : data.price);
                                                return (
                                                    <span className='SpecialPrice p2 demi-bold w-auto p-0 detail_spc' style={{ marginLeft: '5%' }}>
                                                        ₹{formatPrice(finalPrice, { showSymbol: false })}
                                                    </span>
                                                );
                                            })()}
                                           {data?.discount_amount>0 && ( <span className='InitialPrice p3 w-auto p-0'> ₹{formatPrice(data?.price, { showSymbol: false })} </span>)}
                                            <span className='DiscountPriceRound p3 w-auto p-0'> 
                                            {data?.discount_type=='flat'? `${data?.discount_amount} FLAT OFF`:''} 
                                            {data?.discount_type=='percentage'? `${data?.discount_amount}% OFF`:''} </span>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                       
                    ))}
                    </Slider>
                </div>
            </div>
        </div>
                )
            
    )
}

export default Similar